import MemoNoDataFile from "@/assets/NoDataFile";
import { Button } from "@monsterindia/global-ui-components";
import React from "react";

interface NoDataProps {
  heading: string;
  subHeading: string;
  buttonLabel: string;
  buttonUrl: string;
}

const NoData: React.FC<NoDataProps> = ({
  heading,
  subHeading,
  buttonLabel,
  buttonUrl,
}) => {
  return (
    <div className="flex h-[308px] flex-col items-center justify-center gap-4 text-center">
      <MemoNoDataFile height="82" width="91" />
      <p className="text-center text-sm font-semibold leading-5 text-[#59566C]">
        {heading}
      </p>
      <p className="max-w-[513px] text-center text-sm font-normal leading-5 text-[#A5A3AE]">
        {subHeading}
      </p>
      <Button
        label={buttonLabel}
        modifier="secondary"
        size="md"
        url={buttonUrl}
      />
    </div>
  );
};

export default React.memo(NoData);
